import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({
  className,
  appearance = "default",
  ...props
}: React.ComponentProps<"textarea"> & { appearance?: "default" | "form" | "compact" }) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-lg border border-input bg-transparent px-2.5 py-2 text-base transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        appearance === "form"
          ? "min-h-20 rounded-md bg-background text-compact max-sm:text-base dark:bg-background"
          : appearance === "compact"
            ? "min-h-20 rounded-md bg-background px-2.5 py-2 text-compact max-sm:text-base md:text-compact dark:bg-background"
            : "md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
